import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()(theme => ({
  onCallCardWrapper: {
    height: '100%',

    'div > [class*="MuiCardContent-root"]': {
      padding: '0',
    },
  },

  onCallCard: {
    height: '100%',

    section: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    },

    article: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      marginBottom: theme.spacing(3),

      '> section': {
        flex: '65%',

        '& div': {
          marginTop: theme.spacing(1),
        },
      },

      ' > div': {
        flex: '35%',

        '& svg': {
          height: '7rem',
          width: '100%',
        },
      },

      '& button': {
        textIndent: 'inherit',
        padding: '6px 16px', // original value
        marginTop: theme.spacing(2),
      },
    },
  },

  nothingSelected: {
    color: theme.palette.error.main,
  },
}));
